(() => {
    function parseMoney(text) {
        if (!text) return null;

        const cleaned = text.replace(/[^0-9.,]/g, '').replace(/,/g, '');
        const n = Number.parseFloat(cleaned);
        return Number.isFinite(n) ? n : null;
    }

    function fixSavingsBadge(root = document) {
        const spans = root.querySelectorAll?.('.kaching-cart__badge span') ?? [];
        for (const span of spans) {
            const txt = span.textContent || '';
            if (!txt.includes('You save')) continue;
            if (span.dataset.fixed === 'true') continue;

            const cartItem = span.closest('.kaching-cart-item');
            if (!cartItem) continue;

            const oldPriceEl = cartItem.querySelector('.kaching-cart-item__total-old');
            const newPriceEl = cartItem.querySelector('.kaching-cart-item__total-final');

            const oldPrice = parseMoney(oldPriceEl?.textContent);
            const newPrice = parseMoney(newPriceEl?.textContent);

            if (!oldPrice || !newPrice || oldPrice <= 0) continue;

            const exact = 100 - (100 * newPrice / oldPrice);
            const rounded = Math.round(exact * 10) / 10;

            span.textContent = `You save ${rounded}%`;
            span.dataset.fixed = 'true';
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => fixSavingsBadge(document));
    } else {
        fixSavingsBadge(document);
    }

    let queued = false;
    const observer = new MutationObserver((mutations) => {
        if (queued) return;
        queued = true;
        queueMicrotask(() => {
            queued = false;
            fixSavingsBadge(document);
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });
})();